import SideBarItem, { INavItem } from 'app/views/components/navigation-bar/NavItem';
import { useRouting } from 'core/routing/useRouting';

import { DATA_TRACKING_KEY } from '../gainsight/trackingKeys';
import { Logo, LogoLink, SideBarLinkList, SideBarTitleContainer, StyledSideBar } from './NavigationBar.styles';

interface ISideBarProps {
  topItems: INavItem[];
  bottomItems: INavItem[];
}

const SideBar = ({ topItems, bottomItems }: ISideBarProps) => {
  const { routes } = useRouting();
  const logoLink = topItems.find(item => item.link)?.link ?? routes.profile.root;
  return (
    <StyledSideBar>
      <SideBarTitleContainer>
        <LogoLink
          to={logoLink}
          data-tracking={DATA_TRACKING_KEY['main-nav-bar-logo']}
          title="Ideagen Envirosuite"
        >
          <Logo aria-label="Ideagen Envirosuite" />
        </LogoLink>
      </SideBarTitleContainer>
      <SideBarLinkList>
        <SideBarItemList items={topItems} />
        <SideBarItemList items={bottomItems} />
      </SideBarLinkList>
    </StyledSideBar>
  );
};

const SideBarItemList = ({ items }: { items: INavItem[] }) => {
  return (
    <div>
      {items.flatMap(link => {
        if (link.isHidden) return [];
        return <SideBarItem {...link} key={link.key} elementProps={link.elementProps} />;
      })}
    </div>
  );
};

export default SideBar;
